import { inject, Pipe, PipeTransform } from '@angular/core';
import { I18nService } from './i18n.service';
import { formatarMoedaPorIdioma } from './moeda.util';

@Pipe({
  name: 'moeda',
  standalone: true,
  pure: false,
})
export class MoedaPipe implements PipeTransform {
  private i18n = inject(I18nService);

  transform(valor: number | string | null | undefined): string {
    return formatarMoedaPorIdioma(valor, this.i18n.idioma().code, this.i18n.$locale());
  }
}
